import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';

import { api } from '@/api';
import { AttachmentAction, DeleteAction, EditAction } from '@/components/table/actions';
import { getColumnSearchFields } from '@/components/table/filters';
import { PERMISSION_DELETE, PERMISSION_OBJ_CV, PERMISSION_UPDATE } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { cvStore } from '@/stores';
import { showError } from '@/utils/common';
import { getFormattedDate } from '@/utils/moment';
import { getFormattedPriceWithCurrency, getFormattedVolume } from '@/utils/formatters';
import { getFormattedRangeDate } from '@/utils/moment';

const PermissionedEditAction = withPermissions([[PERMISSION_OBJ_CV, PERMISSION_UPDATE]])(EditAction);
const PermissionedDeleteAction = withPermissions([[PERMISSION_OBJ_CV, PERMISSION_DELETE]])(DeleteAction);
const PermissionedAttachmentAction = withPermissions([[PERMISSION_OBJ_CV, PERMISSION_UPDATE]])(AttachmentAction);

const Actions = (_: any, record: any) => {
  const onDelete = () => {
    api.cvs
      .delete(record.id)
      .source.then(() => cvStore.deleteItem(record.id))
      .catch(showError);
  };

  return (
    <Space>
      <PermissionedEditAction uiSref={{ to: 'base-layout.cvs.edit', params: { cvId: record.id } }} />
      <PermissionedAttachmentAction uiSref={{ to: 'base-layout.cvs.attachments', params: { cvId: record.id } }} />
      <PermissionedDeleteAction onConfirm={onDelete} />
    </Space>
  );
};

export const columns = [
  {
    title: <FormattedMessage id="cvs.unlocking-date" />,
    dataIndex: ['unlockingDate'],
    width: 155,
    sorter: true,
    render: getFormattedDate,
  },
  {
    title: <FormattedMessage id="cvs.cv-unlocking" />,
    dataIndex: 'number',
    ...getColumnSearchFields(),
  },
  {
    title: <FormattedMessage id="cvs.period" />,
    dataIndex: 'period',
    width: 150,
    render: getFormattedRangeDate,
  },
  {
    title: <FormattedMessage id="cvs.volume" />,
    dataIndex: 'volume',
    sorter: true,
    render: getFormattedVolume,
  },
  {
    title: <FormattedMessage id="cvs.balance" />,
    dataIndex: 'balance',
    render: getFormattedVolume,
  },
  {
    title: <FormattedMessage id="cvs.counterparty" />,
    dataIndex: ['counterparty', 'name'],
    sorter: true,
  },
  {
    title: <FormattedMessage id="cvs.price" />,
    dataIndex: 'price',
    sorter: true,
    render: getFormattedPriceWithCurrency,
  },
  {
    title: <FormattedMessage id="cvs.campaign" />,
    dataIndex: ['campaign', 'name'],
    sorter: true,
  },
  {
    title: <FormattedMessage id="cvs.taxes" />,
    dataIndex: 'taxes',
    sorter: true,
  },
  {
    title: '',
    render: Actions,
    className: 'actions',
  },
];
